import { request } from '../axios/request';

import {
  STORES_PENDING,
  STORES_REJECTED,
  FETCH_STORES_FULFILLED,
  SET_STORE,
} from '../constants/stores';

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: STORES_PENDING,
});

const rejected = () => ({
  type: STORES_REJECTED,
});

const fulfilled = (response) => ({
  type: FETCH_STORES_FULFILLED,
  response: response,
});

const _setStore = (store) => ({
  type: SET_STORE,
  response: store,
});

export const fetchStores = () => (dispatch) => {
  let allfetchStores = [];
  let paginationCount = 0;
  dispatch(pending());

  request({
    url: `${$U.RETAIL_STORES}?is_active=true`,
    method: 'get',
  })
    .then((response) => {
      paginationCount = response.data.count;
      request({
        url: `${$U.RETAIL_STORES}?is_active=true&limit=${paginationCount}`,
        method: 'get',
      }).then((response) => {
        allfetchStores = response.data.results;
        dispatch(fulfilled(allfetchStores));
      });
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const setStore = (store) => (dispatch) => {
  dispatch(_setStore(store));
};



// WEBPACK FOOTER //
// ./src/actions/stores.js